import styled from 'styled-components';
import {dFlexCenter} from '../../../globalVariables/GlobalFlex';

export type StatusColor = 'brand' | 'highlight' | 'scanned';

export const statusStripPalette: Record<StatusColor, {bg: string; text: string}> = {
    brand: {
        bg: 'linear-gradient(to left, var(--color-brand-subtle) 42%, var(--color-brand-main) 120%)',
        text: 'var(--primitive-turquoise-700)'
    },
    highlight: {
        bg: 'linear-gradient(to left, var(--primitive-yellow-100) 42%, var(--primitive-yellow-400) 120%)',
        text: 'var(--color-text-default)'
    },
    scanned: {
        bg: 'linear-gradient(to left, var(--color-state-warning-bg) 42%, var(--color-state-warning-main) 120%)',
        text: 'var(--primitive-orange-600)'
    }
};

export const strip = styled.div<{$color: StatusColor}>`
    ${dFlexCenter}
    gap: ${({$color}) => ($color === 'scanned' ? '0' : 'var(--space-sm)')};
    width: 100%;
    height: 40px;
    overflow: hidden;
    padding-left: ${({$color}) => ($color === 'scanned' ? 'var(--dimension-8)' : '0')};
    background: ${({$color}) => statusStripPalette[$color].bg};
    color: ${({$color}) => statusStripPalette[$color].text};
    font-size: var(--font-size-body);
    font-weight: var(--font-weight-bold);
    font-variant-numeric: tabular-nums;
`;

export const image = styled.img<{$shiftY?: string}>`
    flex: none;
    height: 63px;
    width: auto;
    object-fit: contain;
    transform: ${({$shiftY}) => ($shiftY ? `translateY(${$shiftY})` : 'none')};
`;
